import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import './AppLayout.css';

function AppLayout() {
  const location = useLocation();

  // O Editor usa layout de tela cheia (sem o wrapper de conteúdo) — mesma
  // regra visual que existia no switch de modoLote === 'editor'.
  const isEditor = location.pathname === '/editor';

  return (
    <div className="cw-app-shell">
      <Sidebar />
      <main className={`cw-app-content${isEditor ? ' cw-app-content--editor' : ''}`}>
        {isEditor ? <Outlet /> : (
          <div className="cw-app-content-inner">
            <Outlet />
          </div>
        )}
      </main>
    </div>
  );
}

export default AppLayout;
